<script lang="ts">
  import Avatar from 'svelte-boring-avatars'

  type Props = {
    name: string
    size?: number
  }
  const { name, size = 32 }: Props = $props()
</script>

<Avatar
  {name}
  colors={[
    'var(--color-picker-blue-solid)',
    'var(--color-picker-cyan-solid)',
    'var(--color-picker-darkblue-solid)',
    'var(--color-picker-darkgreen-solid)',
    'var(--color-picker-fuschia-solid)',
    'var(--color-picker-green-solid)',
    'var(--color-picker-neutral-solid)',
    'var(--color-picker-orange-solid)',
    'var(--color-picker-pink-solid)',
    'var(--color-picker-purple-solid)',
    'var(--color-picker-red-solid)',
    'var(--color-picker-yellow-solid)',
  ]}
  {size}
  variant="beam"
/>
